import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, ToggleButton, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonTypography, TopButton, TopButtonTypography } from '../TestroomTemplate';

type Props = { screenSharing: boolean; onToggle: () => void };

export const TestroomScreenSharing = (props: Props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const enable = !props.screenSharing;
    const isScreenSharing = props.screenSharing;

    return (
        <TopButton>
            <TopButtonTypography>{t('studentScreenSharing')}</TopButtonTypography>
            <ButtonTypography
                sx={{
                    padding: '0px 8px',
                }}>
                <Stack direction='row' justifyContent='center' alignItems='center'>
                    <ToggleButton
                        value='check'
                        selected={isScreenSharing}
                        onChange={async () => {
                            setOpen(true);
                        }}
                        size='small'
                        sx={{ p: 0 }}>
                        {isScreenSharing ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                    </ToggleButton>
                    <Typography>{t('enable')}</Typography>
                </Stack>
            </ButtonTypography>
            <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
                <DialogTitle id='alert-dialog-title'>
                    {enable ? t('enable') : t('disable')} {t('studentScreenSharing')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        {enable ? t('enable') : t('disable')} {t('studentScreenSharing')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>{t('cancel')}</Button>
                    <Button
                        onClick={() => {
                            props.onToggle();
                            setOpen(false);
                        }}
                        autoFocus>
                        {t('confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        </TopButton>
    );
};
